import { z } from 'zod'
import { SuccessEnvelope, Uuid } from './common.js'
import { IdeaStatus } from './idea.js'

// Slim card on a public profile — fewer fields than the validate-ideas card.
const PublicProfileIdea = z.object({
  id: Uuid,
  title: z.string(),
  one_line_pitch: z.string().nullable(),
  industry: z.string().nullable(),
  status: IdeaStatus,
  overall_score: z.number().nullable(),
  number_of_upvotes: z.number(),
  created_at: z.union([z.string(), z.date()]),
})

// Ideas the profile owner has validated. Same slim card, plus the idea's own
// author (these belong to other founders, masked when submitted anonymously).
const PublicProfileValidatedIdea = PublicProfileIdea.extend({
  author: z.string(),
})

export const PublicProfile = z.object({
  handle: z.string(),
  full_name: z.string().nullable(),
  industry: z.string().nullable(),
  industry_group: z.string().nullable().optional(),
  profession: z.string().nullable(),
  persona: z.string().nullable().optional(),
  city: z.string().nullable(),
  pronoun: z.string().nullable().optional(),
  age_range: z.string().nullable().optional(),
  bio: z.string().nullable().optional(),
  // Company name is null when the founder has hidden it.
  company_name: z.string().nullable().optional(),
  startup_stage: z.string().nullable().optional(),
  business_segment: z.string().nullable().optional(),
  looking_for: z.array(z.string()).optional(),
  joined_at: z.union([z.string(), z.date()]),
  is_profile_public: z.boolean(),
  stats: z.object({
    points: z.number(),
    ideas_submitted: z.number(),
    ideas_validated: z.number(),
  }),
  ideas: z.array(PublicProfileIdea),
  ideas_validated_list: z.array(PublicProfileValidatedIdea),
})

export const PublicProfileResponse = SuccessEnvelope(PublicProfile)

export const UpdateHandleResponse = SuccessEnvelope(
  z.object({}).passthrough(), // returns full profileDTO; consumers can extend
)

export const UpdatePrivacyResponse = SuccessEnvelope(
  z.object({ is_profile_public: z.boolean() }),
)
